import React, { useState,useContext } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import FormActions from './FormActions'
import { EyeViewIcon } from '../../icons'
import { userService } from '../../services'
import { AuthContext } from '../../context/AuthContext'



export default function SignUpFormTalent({openVerify}) {
  const [showPassword,setShowPassword] = useState(false);
  const { setUser, setAccessToken, startSilentRefresh ,setSignup} = useContext(AuthContext)

  // const [signup,setSignup]=useState()

  const initialValues = {
    first_name: '',
    email: '',
    password: '',
    otp:'',
  }
  const SignupTalentSchema = Yup.object().shape({
    first_name: Yup.string().required('Please enter first name'),
    email: Yup.string().required('Please enter you email').email('Please enter valid email'),
    password: Yup.string().min(8)
      .matches('^.*[0-9].*$', 'Atleast one number required')
      .matches('^.*[a-zA-Z].*$', 'Atleast one letter required')
      .required('Password is required'),
  })
  return (
    <div className='form__container'>
      <Formik
        initialValues={initialValues}
        validationSchema={SignupTalentSchema}
        onSubmit={(userData) => {
          userService.createSignup(userData).then((response)=>{
            setSignup(response.data.user)
           
            openVerify(true)
          })
          
        }}

      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, isValid, values,
        }) => (
          <div className='signup__form'>
            {/* <div className='input_container'>
              <label>First Name</label>
              <input className={values?.first_name? 'casting_input active':'casting_input'} name='first_name' onChange={handleChange} onBlur={handleBlur}></input>
              <span className='text-xs text-red-600 dark:text-red-400'>{touched?.first_name ? errors?.first_name : null}</span>
            </div>
            <div className='input_container'>
              <label>Your Email</label>
              <input className={values?.email? 'casting_input active':'casting_input'} name='email' onChange={handleChange} onBlur={handleBlur}></input>
              <span className='text-xs text-red-600 dark:text-red-400'>{touched?.email ? errors?.email : null}</span>
            </div>
            <div className='input_container'>
              <label>Password</label>
              <div className='relative'>
                <input className={values?.password? 'casting_input active':'casting_input'} type={showPassword?'text':'password'} name='password' onChange={handleChange} onBlur={handleBlur}></input>
                <EyeViewIcon className='eye_icon' onClick={()=>{setShowPassword(!showPassword)}}/>
              </div>
              <span className='inputfield__info block'>At least 8 characters, 1 uppercase and 1 special character</span>
              <span className='text-xs text-red-600 dark:text-red-400'>{touched?.password ? errors?.password : null}</span>
            </div> */}
            <FormActions onClick={() => { handleSubmit();}} />
          </div>
        )}
      </Formik>
    </div>
  )
}
